import React from 'react';
import ReadOfflineMixin from '../components/resources/read-offline-container';
import ReadOfflineChromebook from '../components/resources/read-offline-chromebook';
import BookStore from '../stores/book-store';
import { toastUtils } from '../utils/toast-utils';
import { isAndroid, isChromebook, isiOS, isSafari } from "../ui/utils/browser";

var ReadOffline = {

  shouldReadOffline: function(){
    //This logic is starting to get nasty. Consider replacing Fraction.Helpers.Browser with Bowser in all cases?
    return Fraction.User && Fraction.Brand.ReadOffline.visible && (!Fraction.User.ssoOnly || !Fraction.Brand.ReadOffline.legacyButton) &&
      ((Fraction.Helpers.Browser.isiOS() && Fraction.Brand.ReadOffline.ios_url) ||
       (Fraction.Helpers.Browser.isAndroid() && Fraction.Brand.ReadOffline.android_url) ||
       (Fraction.Helpers.Browser.isChromebook() && Fraction.Brand.ReadOffline.chrome_url) ||
       (!Fraction.Helpers.Browser.isiOS() && !Fraction.Helpers.Browser.isAndroid() && !Fraction.Helpers.Browser.isChromebook() && Fraction.Brand.ReadOffline.url));
  },

  launchAppURL: function(url){
    if (isiOS()){
      // needs to open in new tab if inside an iframe
      Fraction.Helpers.ssoToOldOnlineURL(url, Fraction.Helpers.Utils.isInIframe());
    } else {
      Jigsaw.User.SSO({destination: url}, function(response){
        if (response.isSuccess()){
          if (Fraction.Helpers.Utils.isInIframe()){
          Fraction.Helpers.toast(i18n.t('sso.popup'));
            window.open(response.data.redirect.autoSignin, "_blank");
          } else if (Fraction.Helpers.Browser.isAndroid() || Fraction.Helpers.Browser.isiOS()) {
            window.location = response.data.redirect.autoSignin;
          } else {
            $("body").append($("<iframe id='read-offline-iframe' style='display:none;' src='"+response.data.redirect.autoSignin+"'></iframe>"));
          }
        }
      });
    }
  },

  launchInChromeApp(){
    Fraction.Helpers.showModal({
      title: <span>{i18n.t('read-offline-chromebook.modal-title', {brand: Fraction.Brand.brand})}</span>,
      content: <ReadOfflineChromebook />,
      closeCallback: function(){},
      definingClass: "modal-box",
      className: "read-offline-chromebook-modal",
      buttons: [],
      width: 360
    });
    setTimeout(function(){
      Fraction.Helpers.removeModal();
    }, 60000);
  },

  launchInApp: function(isbn, show_modal){
    if (Fraction.Helpers.Browser.isChromebook() && Fraction.Brand.ReadOffline.chrome_url) {
      this.launchInChromeApp();
    } else {
      var url = Fraction.Brand.ReadOffline.protocol + "bookshelf";
      if (isbn) {
        url = Fraction.Brand.ReadOffline.protocol+isbn;
        var book = BookStore.get(isbn)
        if (book.viewerIsReady) {
          Fraction.Viewer.Book.getUniversalURL(function(response){
            if (response.isSuccess()){
              url = Fraction.Brand.ReadOffline.protocol+response.data.url.substring(7);
            }
            Fraction.Helpers.launchAppURL(url);
          });
        } else {
          Fraction.Helpers.launchAppURL(url);
        }
      } else {
        Fraction.Helpers.launchAppURL(url);
      }
      if (show_modal && !Fraction.Helpers.isSmallScreen()){
        Fraction.Helpers.showModal({
          title: <span className="offScreen">{i18n.t('main-menu.launch-app')}</span>,
          //content: <div>{toHTML(i18n.t('main-menu.no-launch-app', {brand: Fraction.Brand.brand, link: Fraction.Helpers.getAppURL()}))}</div>,
          //Will is using content line above once we branch apps. Removed for now due to modal showing inconsistent text.
          content: <div>{toHTML(i18n.t('main-menu.no-launch-app', {brand: i18n.t('global-bar.app'), link: Fraction.Helpers.getAppURL()}))}</div>,
          closeCallback: function(){},
          definingClass: "app-modal",
          className: "launch-app-modal",
          hideCloseButton: true,
          buttons: []
        });
        setTimeout(function(){
          Fraction.Helpers.removeModal();
        }, 5000);
      }
    }
  },

  getAppURL: function(){
    var url = "http://support.vitalsource.com/";
    if (!isSafari() || isiOS()) {
      if (isiOS()) {
        url = Fraction.Brand.ReadOffline.ios_url;
      } else if (isAndroid()) {
        url = Fraction.Brand.ReadOffline.android_url;
      } else if (isChromebook()) {
        url = Fraction.Brand.ReadOffline.chrome_url;
      } else {
        url = Fraction.Brand.ReadOffline.url;
      }
    } else {
      url = Fraction.Brand.ReadOffline.url;
    }
    return url;
  },

  downloadApp: function(){
    var url = Fraction.Helpers.getAppURL();
    if (!isSafari() || isAndroid()){
      if (isiOS()) {
        Fraction.Helpers.Locations.safeRedirect(url, "_top");
      } else {
        if (!Fraction.Helpers.Locations.safeRedirect(url, "_blank")){
          Fraction.Helpers.Locations.safeRedirect(url);
        }
      }
    } else {
      Fraction.Helpers.Locations.safeRedirect(url, "_blank");
    }
  },

  continueOfflineMobileModal: function(isbn) {
    toastUtils.dismiss('mobile-offline-toast');
    Fraction.Helpers.showModal({
      title: false,
      content: <ReadOfflineMixin offlineMobile={true} isbn={isbn} />,
      buttons: [],
      definingClass: "read-offline-modal",
      fullscreen: true,
      width: "100%",
      height: "100%",
      bumpUp: true,
      position: {top: 0},
      delegateButtons: true
    });
  },

  hideOfflineToast: function(){
    Fraction.Helpers.saveUserData("SsoToast", true);
    toastUtils.dismiss('mobile-offline-toast');
  },

  mobileReadOfflineToast: function(isbn) {
    const bookshelfName    = Fraction.Helpers.isBookshelfBrand() ? i18n.t('global-bar.bookshelf') : "";
    const hideToastForever = Fraction.Helpers.getUserData('SsoToast') || false;
    const verticalPosition = Fraction.Helpers.isSmallScreen() ? "bottom" : "top";
    if (!hideToastForever) {
      toastUtils.notify({
        id: 'mobile-offline-toast',
        children: (
          <span>
            <button
              className="noButton"
              style={{textAlign: "left"}}
              onClick={ () => {this.continueOfflineMobileModal(isbn)} }
            >
            {i18n.t('main-menu.read-offline-mobile', {bookshelf: bookshelfName, device: Fraction.Helpers.Browser.deviceCheck()})}
            </button>
          </span>
        ),
        imageUrl: "img/bookshelf_mini.svg",
        backgroundColor: "#FFF",
        checkboxText: i18n.t('base.dont-show-again'),
        horizontalPosition: "right",
        imgBtnFn: () => {this.continueOfflineMobileModal(isbn)},
        verticalPosition: verticalPosition,
        dismissible: true,
        onCheckboxChange: this.hideOfflineToast
      });
    }
  },

  readOffline: function(isbn, fromMenu, finishedCallback) {
    // Why do we need a timeout?  Because fraction will redirect
    // if not signed in and proactively use it's onboarding :'(
    return setTimeout(function() {
      Fraction.Helpers.getUser(function() {
        if (Fraction.User && Fraction.Brand.ReadOffline.visible) {
          var userData = Fraction.Helpers.userData();
          if (Fraction.Brand.ReadOffline.interstitial && (Fraction.Helpers.isAndroid() || Fraction.Helpers.isiOS())) {
            if (!Fraction.Helpers.showedReadOffline || fromMenu) {
              Fraction.Helpers.showedReadOffline = true; // Do not show twice in the same session
              var content;
              if (!fromMenu && !userData['readoffline.continueInBrowser']) {
                this.mobileReadOfflineToast(isbn);
              } else if (!userData['readoffline.auto-open'] && fromMenu) {
                content = <ReadOfflineMixin launchOptions={true} isbn={isbn} closeCallback={finishedCallback} />;
              } else {
                if (finishedCallback) { finishedCallback(); }
              }
              if (content) {
                Fraction.Helpers.showModal({
                  title: false,
                  content: content,
                  closeCallback: function() {
                    if (finishedCallback) {
                      return finishedCallback();
                    }
                  },
                  buttons: [],
                  definingClass: "read-offline-modal",
                  fullscreen: true,
                  width: 585,
                  height: 330,
                  delegateButtons: true
                });
                Fraction.Reporter.gaEvent("V3/read-offline", "", "showModal");
              }
            }
            return;
          } else {
            if (fromMenu) {
              Fraction.Helpers.launchInApp(isbn);
              Fraction.Reporter.gaEvent("V3/read-offline", "", "launchAppFromMenu");
            }
          }
        }
        if (finishedCallback) {
          return finishedCallback();
        }
      }.bind(this));
    }.bind(this), 1500);
  }

};

module.exports = ReadOffline;
